import {
  useFirestoreCollectionMutation,
  useFirestoreDocumentData,
  useFirestoreDocumentMutation,
  useFirestoreQuery,
} from '@react-query-firebase/firestore';
import { collection, doc, getDocs, query } from 'firebase/firestore';
import { PuzzleDTO } from 'types';
import { getQuery } from 'services/api/firestore';

import { firestore } from '../Firebase';

export const getAllCollections = () => {
  const ref = query(collection(firestore, 'collections'));
  return useFirestoreQuery(['collections'], ref, {
    subscribe: true,
  });
};

export const getCollectionById = (id: string) => {
  const ref = doc(firestore, 'collections', id);
  return useFirestoreDocumentData(
    ['collection', id],
    ref,
    {
      subscribe: true,
    },
    {
      enabled: Boolean(id),
    },
  );
};

export const editCollection = (id: string) => {
  const ref = doc(collection(firestore, 'collections'), id);
  return useFirestoreDocumentMutation(ref, { merge: true });
};

export const addCollection = () => {
  const collectionRef = collection(firestore, 'collections');
  return useFirestoreCollectionMutation(collectionRef);
};

/**
 * Checks if collection is empty.
 * Optimizes by limiting query to 1 puzzle.
 *
 * @param collectionId
 */
export const isCollectionEmpty = async (collectionId: string) => {
  const minimalCollecionPuzzlesQuery = getQuery<PuzzleDTO>({
    collectionPath: 'puzzles',
    filters: [
      {
        attribute: 'collections',
        operator: 'array-contains',
        value: collectionId,
      },
    ],
    limit: 1,
  });

  // This version of Firebase SDK doesn't have getCountFromServer, we should consider upgrading.
  const querySnapshot = await getDocs(minimalCollecionPuzzlesQuery);
  return querySnapshot.empty;
};
